export default __webpack_public_path__ + "static/media/book.67744290.svg";